(() => {
  const addBusinessDays = (date, numberOfDays) => {
    const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    let remaining = Math.max(0, Number(numberOfDays) || 0);

    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) remaining -= 1;
    }

    return result;
  };

  const formatDate = (date, locale, includeYear) => {
    const options = { day: 'numeric', month: 'long' };
    if (includeYear) options.year = 'numeric';

    try {
      return new Intl.DateTimeFormat(locale || 'fr-CA', options).format(date);
    } catch (error) {
      return new Intl.DateTimeFormat('fr-CA', options).format(date);
    }
  };

  const formatDay = (date, locale) =>
    new Intl.DateTimeFormat(locale || 'fr-CA', { day: 'numeric' }).format(date);

  const formatMonth = (date, locale, includeYear) => {
    const options = { month: 'long' };
    if (includeYear) options.year = 'numeric';
    return new Intl.DateTimeFormat(locale || 'fr-CA', options).format(date);
  };

  const renderEstimate = (estimate) => {
    const range = estimate.querySelector('[data-dija-delivery-range]');
    if (!range) return;

    const minimumDays = parseInt(estimate.dataset.minimumDays, 10) || 7;
    const maximumDays = Math.max(parseInt(estimate.dataset.maximumDays, 10) || 15, minimumDays);
    const locale = estimate.dataset.locale || document.documentElement.lang || 'fr-CA';
    const language = locale.toLowerCase().slice(0, 2);
    const today = new Date();
    const startDate = addBusinessDays(today, minimumDays);
    const endDate = addBusinessDays(today, maximumDays);
    const includeYear = endDate.getFullYear() !== today.getFullYear();
    const sameMonth =
      startDate.getMonth() === endDate.getMonth() &&
      startDate.getFullYear() === endDate.getFullYear();

    if (sameMonth && language === 'en') {
      const month = formatMonth(endDate, locale, includeYear);
      range.textContent = `${month} ${formatDay(startDate, locale)}–${formatDay(endDate, locale)}`;
    } else if (sameMonth) {
      const month = formatMonth(endDate, locale, includeYear);
      range.textContent = `Du ${formatDay(startDate, locale)} au ${formatDay(endDate, locale)} ${month}`;
    } else if (language === 'en') {
      range.textContent = `Between ${formatDate(startDate, locale, includeYear)} and ${formatDate(endDate, locale, includeYear)}`;
    } else {
      range.textContent = `Entre le ${formatDate(startDate, locale, includeYear)} et le ${formatDate(endDate, locale, includeYear)}`;
    }
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-dija-delivery-estimate]').forEach(renderEstimate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
